import {API_ENDPOINTS, PARTNER_PAGE_SIZE} from '../constants';
import {getAuthToken, IAccount} from './account';

export interface IPartner {
    account: {
        OrgName: string;
        AccountOwnerName: string;
        AccountOwnerEmail: string;
        AccountOwnerPhoNum: string;
        city: string;
        name: string;
        title: string;
    };
    created: number;
    database: {name: string; title: string};
    name: string;
    status: 'approved' | 'pending';
    direction: string;
    owner: IAccount | null;
}

const at: string = getAuthToken() || '';

const baseCache = {
    all: null,
    pending: null,
    incoming: null,
    outgoing: null,
};
let cache = {
    [at]: {...baseCache},
};

const getFromCache = (key: string, needle?: string) => {
    const authToken: string = getAuthToken() || '';
    if (!cache[authToken]) resetCache();
    if (needle) return (cache[authToken][key] || []).find((x: any) => x.name === needle);
    return cache[authToken][key];
};
const addToCache = (key: string, value: any) => {
    const authToken: string = getAuthToken() || '';
    if (!cache[authToken]) resetCache();
    if (Array.isArray(cache[authToken][key]))
        cache[authToken][key] = [
            ...cache[authToken][key],
            ...(Array.isArray(value) ? value : [value]),
        ];
    else if (Object.keys(cache[authToken]).includes(key))
        cache[authToken][key] =
            typeof value === 'function' ? value() : Array.isArray(value) ? [...value] : [value];
    else console.error('PARTNERS CACHE MISSING KEY', key);
};
const resetCache = () => {
    const authToken: string = getAuthToken() || '';
    cache = {[authToken]: {...baseCache}};
};

export interface IGetPartnersRequest {
    success: boolean;
    partners: IPartner[];
    partnersPaged?: {
        partners: IPartner[];
        page: {
            page: number;
            current: number;
        };
        hitCount: number;
    };
}
export const get = async (
    endpoint: '' | 'incoming' | 'outgoing' | 'pending' = '',
    page: number = 1
): Promise<IGetPartnersRequest> => {
    const result: IGetPartnersRequest = {
        success: false,
        partners: [],
    };
    const load = async () => {
        try {
            const request = await fetch(
                `${API_ENDPOINTS.partners()}${endpoint ? `/${endpoint}` : ''}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${getAuthToken()}`,
                    },
                }
            );
            if (request.ok) {
                return request.json();
            }
        } catch (ex) {
            console.error(ex);
            alert(
                `There was an error fetching your ${
                    endpoint ? `${endpoint} ` : ''
                }partners. Please reload and try again.`
            );
        }
        return null;
    };
    try {
        const p = await load();
        if (p) {
            result.partners = p.partners;
            result.partnersPaged = p;
            result.success = true;
        }
    } catch (ex) {
        console.error(ex);
        result.success = false;
        alert(
            `There was an error fetching your ${
                endpoint ? `${endpoint} ` : ''
            }partners. Please reload and try again.`
        );
    }
    return result;
};

export const count = async (): Promise<{success: boolean; count: number}> => {
    const result: {success: boolean; count: number} = {
        success: false,
        count: 0,
    };
    try {
        const request = await fetch(`${API_ENDPOINTS.pendingPartnersCount()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getAuthToken()}`,
            },
        });
        if (request.ok) {
            const parsedResult = await request.json();
            result.count = parsedResult.count;
            result.success = true;
        }
    } catch (ex) {
        console.error(ex);
        alert(
            `There was an error fetching your prending partner count. Please reload and try again.`
        );
    }
    return result;
};

export const add: (
    accountName: string,
    databaseName: string
) => Promise<{success: boolean; message: string}> = async (
    accountName: string,
    databaseName: string
) => {
    const result = {
        success: false,
        message: '',
    };
    try {
        const request = await fetch(API_ENDPOINTS.partners(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getAuthToken()}`,
            },
            body: JSON.stringify({
                accountName,
                databaseName,
            }),
        });
        if (request.ok) {
            await request.json();
            // await approve(x.name)
            result.success = true;
        }
    } catch (ex) {
        console.error(ex);
        result.success = false;
        alert('There was an error adding one or more partners. Please reload and try again.');
    }
    resetCache();
    return result;
};

export const approve: (name: string) => Promise<{success: boolean; message: string}> = async (
    name: string
) => {
    const result = {
        success: false,
        message: '',
    };
    try {
        const request = await fetch(`${API_ENDPOINTS.partners()}/${name}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getAuthToken()}`,
            },
            body: JSON.stringify({}), // body required for modsec
        });
        const x = await request.text();
        result.message = x;
        if (request.ok) {
            result.success = true;
        }
    } catch (ex) {
        console.error(ex);
        result.success = false;
        alert('There was an error approving one or more partners. Please reload and try again.');
    }
    resetCache();
    return result;
};

export const reject: (name: string) => Promise<{success: boolean; message: string}> = async (
    name: string
) => {
    const result = {
        success: false,
        message: '',
    };
    try {
        const request = await fetch(`${API_ENDPOINTS.partners()}/${name}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getAuthToken()}`,
            },
            body: JSON.stringify({}), // body required for modsec
        });
        const x = await request.text();
        result.message = x;
        if (request.ok) {
            result.success = true;
        }
    } catch (ex) {
        console.error(ex);
        result.success = false;
        alert('There was an error removing one or more partners. Please reload and try again.');
    }
    resetCache();
    return result;
};



// WEBPACK FOOTER //
// ./src/services/partner.ts